import React, { ReactNode } from "react";
import { FormFieldStyle as S } from "./FormField.style";
import {
  Controller,
  ControllerFieldState,
  ControllerProps,
  ControllerRenderProps,
  FieldValues,
  Path,
  UseFormReturn,
  useFormState,
  UseFormStateReturn,
} from "react-hook-form";
import { FormFieldError } from "./FormFieldError/FormFieldError";
import { InfoTooltip } from "components/InfoTooltip/InfoTooltip";

export const FormField = <TForm extends {}>(
  props: {
    header?: string | ReactNode | true;
    className?: string;
    noError?: boolean;
    infoTooltip?: string;

    form: UseFormReturn<TForm, {}>;
    input: (field: {
      field: ControllerRenderProps<FieldValues, string>;
      fieldState: ControllerFieldState;
      formState: UseFormStateReturn<FieldValues>;
    }) => ReactNode;
    name: Path<TForm>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } & Omit<ControllerProps<FieldValues, any>, "control" | "render" | "name">,
) => {
  const { className, ...cleanProps } = props;
  const { isSubmitted } = useFormState(props.form);
  return (
    <S.FormField className={className}>
      <Controller
        {...cleanProps}
        control={props.form.control as never}
        render={(r) => {
          const component = props.input(r);
          return (
            <>
              <S.FieldWrapper className={!props.noError && r.fieldState.invalid ? "form-field-invalid" : ""}>
                {!!props.header && (
                  <S.Header className="form-field-header">
                    {props.header || props.name}&nbsp;
                    {props.infoTooltip && <InfoTooltip>{props.infoTooltip}</InfoTooltip>}
                  </S.Header>
                )}
                {component}
              </S.FieldWrapper>
              {!props.noError && (
                <FormFieldError
                  rules={props.rules}
                  isSubmitted={isSubmitted}
                  nameOrHeader={(props.header !== false && props.header) || props.name.toString()}
                  fieldState={r.fieldState}
                />
              )}
            </>
          );
        }}
      />
    </S.FormField>
  );
};
